'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _meContext = require('../../../helpers/contexts/meContext');

var _resendVerificationEmailContext = require('../../../helpers/contexts/resendVerificationEmailContext');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Component(props) {
  return _react2.default.createElement(
    _meContext.MeContext.Provider,
    { value: props.me },
    _react2.default.createElement(
      _resendVerificationEmailContext.ResendVerificationEmailContext.Provider,
      { value: props.resendVerificationEmail },
      props.children
    )
  );
}

Component.propTypes = {
  me: _propTypes2.default.object,
  children: _propTypes2.default.node,
  resendVerificationEmail: _propTypes2.default.func
};

exports.default = Component;